import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BehaviorSubject } from "rxjs";

@Injectable()

export class NavigationService {
  
  private navigationSubject: BehaviorSubject<string>;
  navigation$: Observable<string>;

  constructor() { 
    const initialNavigation = this.getNavigation() || "side";
    this.navigationSubject = new BehaviorSubject<string>(initialNavigation);
    this.navigation$ = this.navigationSubject.asObservable();
  }
  
  
  resetNavigation() {
    localStorage.removeItem("navigation");
    this.navigationSubject.next("side");
  }

  setNavigation(state: string) {
    localStorage.setItem("navigation", state);
    this.navigationSubject.next(state);
  }

  getNavigation(): string {
    return localStorage.getItem("navigation")
  }
}


// WEBPACK FOOTER //
// /usr/src/app/src/app/_services/navigation.service.ts